<template>
  <div class="pb-14 mb-14">
    <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <h3 class="text-center mb-0 pb-0">{{ modulo.nombre }}</h3>
    <h4 class="text-center mt-0 pt-0">Calificaciones del modulo.</h4>
    <div class="d-flex justify-center">
      <div>
        <v-img :src="base64cert" width="180"></v-img>
      </div>
    </div>
    <v-progress-linear indeterminate v-if="loadingcert"></v-progress-linear>
    <v-progress-linear v-if="loading" indeterminate />

    <div class="d-flex justify-center mb-2">
      <v-btn small class="" @click="vercalificaciones()" color="purple" tile outlined>
        <v-icon left small>mdi-account</v-icon> Registrar calificaciones
      </v-btn>
    </div>

    <v-data-table :headers="headers" :items="modulo.inscripciones" :itemsPerPage="-1" dense class="elevation-2">
      <template v-slot:[`item.estudiante`]="{ item }">
        <span>
          {{ item.estudiante.primer_apellido }} {{ item.estudiante.segundo_apellido }}
          {{ item.estudiante.nombres }}
        </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom v-if="item.inscritos != 0">
          <template #activator="{ on, attrs }">
            <v-icon class="ma-2" v-bind="attrs" v-on="on" @click="openCertificado(item)">
              mdi-certificate-outline
            </v-icon>
          </template>
          Generar Certificado
        </v-tooltip>

        <v-tooltip bottom v-if="item.inscritos != 0">
          <template #activator="{ on, attrs }">
            <v-icon class="ma-2" v-bind="attrs" v-on="on" @click="descargarCertificadoNotas(item)">
              mdi-book-open-variant
            </v-icon>
          </template>
          Certificado de notas
        </v-tooltip>
      </template>
    </v-data-table>

    <v-tooltip>
      <template #activator="{ on, attrs }">
        <v-icon class="ma-2" v-bind="attrs" v-on="on" @click="descargarActaNotas()">
          mdi-book-open-page-variant-outline
        </v-icon>
      </template>
      Acta de notas
    </v-tooltip>

    <Certificado ref="certificado" />
    <div>
      <Notascert ref="notascert" />
    </div>
    <div>
      <NotasActa ref="notasacta" />
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import Certificado from './certificado.vue';
  import Notascert from './notascert.vue';
  import NotasActa from './notasActa.vue';
  import gql from 'graphql-tag';
  export default {
    data: () => ({
      loading: false,
      base64cert: null,
      loadingcert: false,
      modulo: { inscripciones: [] },
      posgrado: null,
      headers: [
        { text: 'Estudiante', value: 'estudiante' },
        { text: 'Nota final', value: 'nota_final', width: 50 },
        { text: 'Nota recuperatorio', value: 'nota_recuperatorio', width: 80 },

        { text: 'Acciones', value: 'actions' },
      ],
    }),

    components: { Certificado, Notascert, NotasActa },
    computed: {
      permitidoedit() {
        let iduser = this.$store.state.CARGO.id;
        return iduser == 1 || iduser == 8 || iduser == 6 || iduser == 7;
      },
    },
    watch: {},

    methods: {
      cargarInscritos() {
        let vue = this;
        this.loading = true;
        this.modulo = { inscripciones: [] };
        let idmodulo = this.$route.query.idmodulo;
        const promise1 = xaxios.get(`${process.env.VUE_APP_API_REST}/esam/inscripcion/modulo/id/${idmodulo}`);
        this.getSaveData();
        //const promise2 = axios.get(`${process.env.VUE_APP_API_REST}/esam/programa/id/100`);
        Promise.all([promise1])
          .then(function(values) {
            let data = values[0].data;
            //let data1 = values[1].data;
            //window.console.log(data1);
            vue.loading = false;
            data.inscripciones.sort((a, b) => {
              return a.estudiante.primer_apellido.localeCompare(b.estudiante.primer_apellido);
            });
            vue.modulo = data;
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
          });
        this.getDatos();
      },
      getDatos() {
        let idpostgrado = this.$route.query.idpostgrado;
        const qs = gql`query{ getPostgrado(id:${idpostgrado}){ id nombre carga_horaria } }`;
        this.$apollo
          .query({ query: qs })
          .then(({ data: { getPostgrado } }) => {
            this.posgrado = getPostgrado;
          })
          .catch(() => this.$root.$notify.show(`No hay datos`, { color: 'primary' }));
      },
      openCertificado(estudiante) {
        let nota_aprobacion = 50;
        if (estudiante.nota_final > nota_aprobacion || estudiante.nota_recuperatorio > nota_aprobacion) {
          this.$refs.certificado.openmodal(estudiante, this.modulo, this.posgrado);
        } else {
          this.$root.$notify.show(`Nota(${estudiante.nota_final}) no aprobada.`, {
            color: 'red',
            x: 'top',
          });
          return;
        }
      },
      getSaveData() {
        let programa_modulo_id = this.$route.query.programa_modulo_id;
        let vue = this;
        this.loadingcert = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/programamodulocertificado/${programa_modulo_id}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(data);
            if (data) {
              if (data.archivo) {
                vue.base64cert = `data:${data.archivo.mimetype};base64,${data.archivo.file64}`;
              }
            }
            vue.loadingcert = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingcert = false;
          });
      },
      vercalificaciones() {
        if (this.permitidoedit) {
          let idpostgrado = this.$route.query.idpostgrado;
          let idmodulo = this.$route.query.idmodulo;
          let plataforma = this.$route.query.plataforma;
          const plataformaId = this.$route.query.plataforma_id;
          // window.console.log('plataforma:::',plataforma);
          let course_id = this.modulo.course_id;
          this.$router.push(
            `/calificaciones_reg?idmodulo=${idmodulo}&idpostgrado=${idpostgrado}&course_id=${course_id}&plataforma_id=${plataformaId}&plataforma=${plataforma}`,
          );
        } else {
          this.$root.$notify.show(`No tienes autorizacion para esta accion.`, {
            color: 'danger',
            x: 'left',
          });
        }
      },
      descargarCertificadoNotas(item) {
        this.$refs.notascert.openmodal(item.estudiante.usuario_moodle);
      },
      descargarActaNotas() {
        this.$refs.notasacta.openmodal(this.modulo, this.posgrado);
      },
    },
    mounted() {
      this.cargarInscritos();
    },
  };
</script>
